import React from 'react';
import PropTypes from 'prop-types';

import SortSelection, {
  createSortSelection,
  createSortOrderSelection,
} from '../../common/SortSelection';
import OrderSortOrderBy from '../../../types/order/OrderSortOrderBy';
import SortOrder from '../../../types/SortOrder';
import { observer } from 'mobx-react';
import globalTranslations from '../../../i18n/globalTranslations';

const sortOrderSelections = [
  createSortOrderSelection(globalTranslations.descendingTitle, SortOrder.DESC),
  createSortOrderSelection(globalTranslations.ascendingTitle, SortOrder.ASC),
];

const OrderListSortSelection = ({
  onSelectSort,
  onSelectSortOrder,
  selectedSortKey,
  selectedSortOrder,
}) => {
  const sortSelections = [
    createSortSelection(
      globalTranslations.orderNumber,
      OrderSortOrderBy.ORDERS_ID,
      selectedSortOrder,
      1
    ),
    createSortSelection(
      globalTranslations.referenceTitle,
      OrderSortOrderBy.REFERENCE,
      selectedSortOrder,
      2
    ),
    createSortSelection(
      globalTranslations.orderDate,
      OrderSortOrderBy.DATE_PURCHASED,
      selectedSortOrder,
      3
    ),
    createSortSelection(
      globalTranslations.deliveryDateTitle,
      OrderSortOrderBy.DELIVERY_DATE,
      selectedSortOrder,
      4
    ),
    createSortSelection(
      globalTranslations.numberOfProductsTitle,
      OrderSortOrderBy.NUMBER_OF_PRODUCTS,
      selectedSortOrder,
      5
    ),
    createSortSelection(
      globalTranslations.statusTitle,
      OrderSortOrderBy.STATUS,
      selectedSortOrder,
      6
    ),
    createSortSelection(
      globalTranslations.totalPriceSentence,
      OrderSortOrderBy.TOTAL,
      selectedSortOrder,
      7
    ),
  ];

  return (
    <SortSelection
      className={'OrderListSortSelection'}
      sortSelections={sortSelections}
      onSelectSort={onSelectSort}
      selectedSortKey={selectedSortKey}
      selectedSortOrder={selectedSortOrder}
      onSelectSortOrder={onSelectSortOrder}
      sortOrderSelections={sortOrderSelections}
    />
  );
};

OrderListSortSelection.propTypes = {
  onSelectSort: PropTypes.func.isRequired,
  onSelectSortOrder: PropTypes.func.isRequired,
  selectedSortKey: PropTypes.string,
  selectedSortOrder: PropTypes.string,
};

OrderListSortSelection.defaultProps = {
  selectedSortOrder: SortOrder.DESC,
};

export default observer(OrderListSortSelection);
